export const chlngersUrl =
  'https://d246jgzr1jye8u.cloudfront.net/development/img/chlngers-icon.png';

export const itemUrl =
  'https://d246jgzr1jye8u.cloudfront.net/development/admin/1675940603239-0.png';

export const wireframeUrl =
  'https://react.semantic-ui.com/images/wireframe/image.png';
